import { useState, useEffect } from 'react'
import { TwitterPicker } from 'react-color'
import { themeColor } from 'shared'

export const ColorInput = (props) => {
  const [visible, setVisible] = useState(false)
  const [value, setValue] = useState(props.control.value)

  useEffect(() => { props.control.value = value }, [value])

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      setVisible(false)
    }
  }

  const handleColorChange = (event) => {
    setValue(event.hex.replace('#', ''))
  }

  const colors = [
    themeColor('green-500'),
    themeColor('green-700'),
    themeColor('green-900'),
    themeColor('yellow-400'),
    themeColor('orange-500'),
    themeColor('red-700'),
    themeColor('red-900'),
    themeColor('orange-700'),
    themeColor('blue-400'),
    themeColor('blue-700'),
    themeColor('blue-900'),
    themeColor('purple-400'),
    themeColor('purple-700'),
    themeColor('gray-500'),
    themeColor('gray-700'),
    themeColor('gray-900'),
  ]

  const popoverStyle = {
    position: 'absolute',
    zIndex: 2,
    top: 40,
    left: -5,
  }

  const coverStyle = {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  }

  return <div className='input-group'>
    <div style={{
      background: `#${value} none repeat scroll 0% 0%`,
      height: 30,
      width: 30,
      cursor: 'pointer',
      position: 'relative',
      borderRadius: 4,
      margin: '0px 6px 6px 0px',
      border: `1px solid ${themeColor('gray-300')}`
    }} onClick={() => setVisible(true)} title={`#${value}`} tabIndex={0} />

    {visible && <div style={popoverStyle} onKeyDown={handleEnter}>
      <div style={coverStyle} onClick={() => setVisible(false)} />
      <TwitterPicker colors={colors} color={value} onChangeComplete={handleColorChange} styles={{ default: {input: { height: '30px' }}}} />
    </div>}
  </div>
}
